import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { useSnackbar } from "notistack";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const KEY_CODES = {
  ENTER: 13,
  ESCAPE: 27,
};

const FormHoc = (component) =>
  React.forwardRef((props, ref) => {
    const Component = component;

    const [open, setOpen] = React.useState(false);
    const [newItem, setNewItem] = React.useState(null);
    const [initialValues, setInitialValues] = React.useState(null);
    const [initializedValues, setInitializedValues] = React.useState(null);

    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          setOpen(false);
        }
        const tabbables = document.getElementsByTagName("input");
        const i = [...tabbables]?.indexOf(e.target);

        if (e.key === "ArrowRight") {
          tabbables?.[i + 1]?.focus();
        }

        if (e.key === "ArrowLeft") {
          tabbables?.[i - 1]?.focus();
        }
      });

      return () => document.removeEventListener("keydown", () => {});
    }, []);

    React.useImperativeHandle(ref, () => ({
      open(e) {
        setNewItem(true);
        setInitialValues(e);
        setOpen(true);
      },
      edit(e) {
        setNewItem(false);
        setInitialValues(e);
        setOpen(true);
      },
      initialize(e) {
        setNewItem(true);
        setInitializedValues(e);
        setOpen(true);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };

    const onKeyDown = (keyEvent) => {
      if ((keyEvent.charCode || keyEvent.keyCode) === KEY_CODES.ENTER) {
        const form = keyEvent.target.form;

        const index = Array.prototype.indexOf.call(form, keyEvent.target);
        form.elements?.[index + 1]?.focus();
        keyEvent.preventDefault();
      }
    };

    const snSuccess = (msg) => {
      enqueueSnackbar(msg, { variant: "success" });
    };

    const snError = (msg) => {
      enqueueSnackbar(msg, { variant: "error" });
    };

    return (
      <Dialog
        open={open}
        fullWidth
        fullScreen
        TransitionComponent={Transition}
        disableEscapeKeyDown
      >
        <Component
          {...props}
          onClose={handleClose}
          newItem={newItem}
          initialValues={initialValues}
          initializedValues={initializedValues}
          onKeyDown={onKeyDown}
          snSuccess={snSuccess}
          snError={snError}
        />
      </Dialog>
    );
  });

export default FormHoc;
